import { Component, Input } from '@angular/core';
import { IdentificacaoAtendimento } from 'src/app/models/Servico.model';

@Component({
  selector: 'app-confirmacao-solicitacao',
  templateUrl: './confirmacao-solicitacao.component.html',
  styleUrls: ['./confirmacao-solicitacao.component.css'],
})
export class ConfirmacaoSolicitacaoComponent {
  @Input({ required: true }) dadosConfirmacao!: IdentificacaoAtendimento;
  @Input() mostrarPesquisa: boolean = true;
}
